// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file message/message_requests.proto (package com.gem.bff.contract, syntax proto3)

/* eslint-disable */
import type { Message } from '@bufbuild/protobuf';
import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';

import type { GraphicSize, LinkPreview } from '../common/common_model_pb';
import { file_common_common_model } from '../common/common_model_pb';
import type { Message_DeleteMode, Message_Direction, Message_MediaType } from './message_model_pb';
import { file_message_message_model } from './message_model_pb';

/**
 * Describes the file message/message_requests.proto.
 */
export const file_message_message_requests: GenFile =
  /*@__PURE__*/
  fileDesc(
    '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',
    [file_message_message_model, file_common_common_model]
  );

/**
 * @generated from message com.gem.bff.contract.GetMessagesRequest
 */
export type GetMessagesRequest = Message<'com.gem.bff.contract.GetMessagesRequest'> & {
  /**
   * @generated from field: int64 chatId = 1;
   */
  chatId: bigint;

  /**
   * @generated from field: com.gem.bff.contract.Message.Direction direction = 2;
   */
  direction: Message_Direction;

  /**
   * @generated from field: optional int64 cursorTs = 3;
   */
  cursorTs?: bigint;

  /**
   * @generated from field: optional int32 count = 4;
   */
  count?: number;
};

/**
 * Describes the message com.gem.bff.contract.GetMessagesRequest.
 * Use `create(GetMessagesRequestSchema)` to create a new message.
 */
export const GetMessagesRequestSchema: GenMessage<GetMessagesRequest> =
  /*@__PURE__*/
  messageDesc(file_message_message_requests, 0);

/**
 * @generated from message com.gem.bff.contract.GetMessagesByMediaTypesRequest
 */
export type GetMessagesByMediaTypesRequest =
  Message<'com.gem.bff.contract.GetMessagesByMediaTypesRequest'> & {
    /**
     * @generated from field: int64 chatId = 1;
     */
    chatId: bigint;

    /**
     * @generated from field: com.gem.bff.contract.Message.Direction direction = 2;
     */
    direction: Message_Direction;

    /**
     * @generated from field: repeated com.gem.bff.contract.Message.MediaType mediaTypes = 3;
     */
    mediaTypes: Message_MediaType[];

    /**
     * @generated from field: optional int64 cursorTs = 4;
     */
    cursorTs?: bigint;
  };

/**
 * Describes the message com.gem.bff.contract.GetMessagesByMediaTypesRequest.
 * Use `create(GetMessagesByMediaTypesRequestSchema)` to create a new message.
 */
export const GetMessagesByMediaTypesRequestSchema: GenMessage<GetMessagesByMediaTypesRequest> =
  /*@__PURE__*/
  messageDesc(file_message_message_requests, 1);

/**
 * @generated from message com.gem.bff.contract.UpdateMessageRequest
 */
export type UpdateMessageRequest = Message<'com.gem.bff.contract.UpdateMessageRequest'> & {
  /**
   * @generated from field: int64 chatId = 1;
   */
  chatId: bigint;

  /**
   * @generated from field: int64 messageId = 2;
   */
  messageId: bigint;

  /**
   * @generated from field: com.gem.bff.contract.SendMessagePayloadData payload = 3;
   */
  payload?: SendMessagePayloadData;
};

/**
 * Describes the message com.gem.bff.contract.UpdateMessageRequest.
 * Use `create(UpdateMessageRequestSchema)` to create a new message.
 */
export const UpdateMessageRequestSchema: GenMessage<UpdateMessageRequest> =
  /*@__PURE__*/
  messageDesc(file_message_message_requests, 2);

/**
 * @generated from message com.gem.bff.contract.SendMessageRequest
 */
export type SendMessageRequest = Message<'com.gem.bff.contract.SendMessageRequest'> & {
  /**
   * @generated from field: int64 chatId = 1;
   */
  chatId: bigint;

  /**
   * @generated from field: int64 clientTs = 2;
   */
  clientTs: bigint;

  /**
   * @generated from field: string clientUuid = 3;
   */
  clientUuid: string;

  /**
   * @generated from field: optional bool retry = 4;
   */
  retry?: boolean;

  /**
   * @generated from field: optional int64 quotedMessageId = 5;
   */
  quotedMessageId?: bigint;

  /**
   * @generated from field: com.gem.bff.contract.SendMessagePayloadData payload = 6;
   */
  payload?: SendMessagePayloadData;

  /**
   * @generated from field: optional com.gem.bff.contract.QuotedMessageRequestData quotedMessageData = 7;
   */
  quotedMessageData?: QuotedMessageRequestData;
};

/**
 * Describes the message com.gem.bff.contract.SendMessageRequest.
 * Use `create(SendMessageRequestSchema)` to create a new message.
 */
export const SendMessageRequestSchema: GenMessage<SendMessageRequest> =
  /*@__PURE__*/
  messageDesc(file_message_message_requests, 3);

/**
 * @generated from message com.gem.bff.contract.QuotedMessageRequestData
 */
export type QuotedMessageRequestData = Message<'com.gem.bff.contract.QuotedMessageRequestData'> & {
  /**
   * @generated from field: int64 sourceChatId = 1;
   */
  sourceChatId: bigint;

  /**
   * @generated from field: int64 sourceMessageId = 2;
   */
  sourceMessageId: bigint;

  /**
   * @generated from field: optional string text = 3;
   */
  text?: string;
};

/**
 * Describes the message com.gem.bff.contract.QuotedMessageRequestData.
 * Use `create(QuotedMessageRequestDataSchema)` to create a new message.
 */
export const QuotedMessageRequestDataSchema: GenMessage<QuotedMessageRequestData> =
  /*@__PURE__*/
  messageDesc(file_message_message_requests, 4);

/**
 * @generated from message com.gem.bff.contract.GetRangeAroundMessageRequest
 */
export type GetRangeAroundMessageRequest =
  Message<'com.gem.bff.contract.GetRangeAroundMessageRequest'> & {
    /**
     * @generated from field: int64 chatId = 1;
     */
    chatId: bigint;

    /**
     * @generated from field: int64 messageId = 2;
     */
    messageId: bigint;

    /**
     * @generated from field: optional int32 halfLimit = 3;
     */
    halfLimit?: number;
  };

/**
 * Describes the message com.gem.bff.contract.GetRangeAroundMessageRequest.
 * Use `create(GetRangeAroundMessageRequestSchema)` to create a new message.
 */
export const GetRangeAroundMessageRequestSchema: GenMessage<GetRangeAroundMessageRequest> =
  /*@__PURE__*/
  messageDesc(file_message_message_requests, 5);

/**
 * @generated from message com.gem.bff.contract.GetMessagesByIdsRequest
 */
export type GetMessagesByIdsRequest = Message<'com.gem.bff.contract.GetMessagesByIdsRequest'> & {
  /**
   * @generated from field: int64 chatId = 1;
   */
  chatId: bigint;

  /**
   * @generated from field: repeated int64 messageIds = 2;
   */
  messageIds: bigint[];
};

/**
 * Describes the message com.gem.bff.contract.GetMessagesByIdsRequest.
 * Use `create(GetMessagesByIdsRequestSchema)` to create a new message.
 */
export const GetMessagesByIdsRequestSchema: GenMessage<GetMessagesByIdsRequest> =
  /*@__PURE__*/
  messageDesc(file_message_message_requests, 6);

/**
 * @generated from message com.gem.bff.contract.GetMessagesAroundTsRequest
 */
export type GetMessagesAroundTsRequest =
  Message<'com.gem.bff.contract.GetMessagesAroundTsRequest'> & {
    /**
     * @generated from field: int64 chatId = 1;
     */
    chatId: bigint;

    /**
     * @generated from field: int64 ts = 2;
     */
    ts: bigint;

    /**
     * @generated from field: optional int32 halfLimit = 3;
     */
    halfLimit?: number;
  };

/**
 * Describes the message com.gem.bff.contract.GetMessagesAroundTsRequest.
 * Use `create(GetMessagesAroundTsRequestSchema)` to create a new message.
 */
export const GetMessagesAroundTsRequestSchema: GenMessage<GetMessagesAroundTsRequest> =
  /*@__PURE__*/
  messageDesc(file_message_message_requests, 7);

/**
 * @generated from message com.gem.bff.contract.GetRangeAroundNextUserMentionRequest
 */
export type GetRangeAroundNextUserMentionRequest =
  Message<'com.gem.bff.contract.GetRangeAroundNextUserMentionRequest'> & {
    /**
     * @generated from field: int64 chatId = 1;
     */
    chatId: bigint;

    /**
     * @generated from field: int64 startTs = 2;
     */
    startTs: bigint;

    /**
     * @generated from field: int32 halfLimit = 3;
     */
    halfLimit: number;
  };

/**
 * Describes the message com.gem.bff.contract.GetRangeAroundNextUserMentionRequest.
 * Use `create(GetRangeAroundNextUserMentionRequestSchema)` to create a new message.
 */
export const GetRangeAroundNextUserMentionRequestSchema: GenMessage<GetRangeAroundNextUserMentionRequest> =
  /*@__PURE__*/
  messageDesc(file_message_message_requests, 8);

/**
 * @generated from message com.gem.bff.contract.GetUsersReactionsForMessageRequest
 */
export type GetUsersReactionsForMessageRequest =
  Message<'com.gem.bff.contract.GetUsersReactionsForMessageRequest'> & {
    /**
     * @generated from field: int64 chatId = 1;
     */
    chatId: bigint;

    /**
     * @generated from field: int64 messageId = 2;
     */
    messageId: bigint;

    /**
     * @generated from field: optional int64 reactionId = 3;
     */
    reactionId?: bigint;
  };

/**
 * Describes the message com.gem.bff.contract.GetUsersReactionsForMessageRequest.
 * Use `create(GetUsersReactionsForMessageRequestSchema)` to create a new message.
 */
export const GetUsersReactionsForMessageRequestSchema: GenMessage<GetUsersReactionsForMessageRequest> =
  /*@__PURE__*/
  messageDesc(file_message_message_requests, 9);

/**
 * @generated from message com.gem.bff.contract.AddMessageReactionRequest
 */
export type AddMessageReactionRequest =
  Message<'com.gem.bff.contract.AddMessageReactionRequest'> & {
    /**
     * @generated from field: int64 chatId = 1;
     */
    chatId: bigint;

    /**
     * @generated from field: int64 messageId = 2;
     */
    messageId: bigint;

    /**
     * @generated from field: int64 reactionId = 3;
     */
    reactionId: bigint;
  };

/**
 * Describes the message com.gem.bff.contract.AddMessageReactionRequest.
 * Use `create(AddMessageReactionRequestSchema)` to create a new message.
 */
export const AddMessageReactionRequestSchema: GenMessage<AddMessageReactionRequest> =
  /*@__PURE__*/
  messageDesc(file_message_message_requests, 10);

/**
 * @generated from message com.gem.bff.contract.RemoveMessageReactionRequest
 */
export type RemoveMessageReactionRequest =
  Message<'com.gem.bff.contract.RemoveMessageReactionRequest'> & {
    /**
     * @generated from field: int64 chatId = 1;
     */
    chatId: bigint;

    /**
     * @generated from field: int64 messageId = 2;
     */
    messageId: bigint;

    /**
     * @generated from field: int64 reactionId = 3;
     */
    reactionId: bigint;
  };

/**
 * Describes the message com.gem.bff.contract.RemoveMessageReactionRequest.
 * Use `create(RemoveMessageReactionRequestSchema)` to create a new message.
 */
export const RemoveMessageReactionRequestSchema: GenMessage<RemoveMessageReactionRequest> =
  /*@__PURE__*/
  messageDesc(file_message_message_requests, 11);

/**
 * @generated from message com.gem.bff.contract.GetUsersViewedMessageRequest
 */
export type GetUsersViewedMessageRequest =
  Message<'com.gem.bff.contract.GetUsersViewedMessageRequest'> & {
    /**
     * @generated from field: int64 chatId = 1;
     */
    chatId: bigint;

    /**
     * @generated from field: int64 messageId = 2;
     */
    messageId: bigint;

    /**
     * @generated from field: optional int32 limit = 3;
     */
    limit?: number;

    /**
     * @generated from field: optional string cursor = 4;
     */
    cursor?: string;
  };

/**
 * Describes the message com.gem.bff.contract.GetUsersViewedMessageRequest.
 * Use `create(GetUsersViewedMessageRequestSchema)` to create a new message.
 */
export const GetUsersViewedMessageRequestSchema: GenMessage<GetUsersViewedMessageRequest> =
  /*@__PURE__*/
  messageDesc(file_message_message_requests, 12);

/**
 * @generated from message com.gem.bff.contract.IncreaseViewsRequest
 */
export type IncreaseViewsRequest = Message<'com.gem.bff.contract.IncreaseViewsRequest'> & {
  /**
   * @generated from field: int64 chatId = 1;
   */
  chatId: bigint;

  /**
   * @generated from field: repeated int64 messageIds = 2;
   */
  messageIds: bigint[];
};

/**
 * Describes the message com.gem.bff.contract.IncreaseViewsRequest.
 * Use `create(IncreaseViewsRequestSchema)` to create a new message.
 */
export const IncreaseViewsRequestSchema: GenMessage<IncreaseViewsRequest> =
  /*@__PURE__*/
  messageDesc(file_message_message_requests, 13);

/**
 * @generated from message com.gem.bff.contract.ForwardMessagesRequest
 */
export type ForwardMessagesRequest = Message<'com.gem.bff.contract.ForwardMessagesRequest'> & {
  /**
   * @generated from field: int64 chatId = 1;
   */
  chatId: bigint;

  /**
   * @generated from field: repeated com.gem.bff.contract.ForwardMessagesRequest.ForwardData messagesToForward = 2;
   */
  messagesToForward: ForwardMessagesRequest_ForwardData[];
};

/**
 * Describes the message com.gem.bff.contract.ForwardMessagesRequest.
 * Use `create(ForwardMessagesRequestSchema)` to create a new message.
 */
export const ForwardMessagesRequestSchema: GenMessage<ForwardMessagesRequest> =
  /*@__PURE__*/
  messageDesc(file_message_message_requests, 14);

/**
 * @generated from message com.gem.bff.contract.ForwardMessagesRequest.ForwardData
 */
export type ForwardMessagesRequest_ForwardData =
  Message<'com.gem.bff.contract.ForwardMessagesRequest.ForwardData'> & {
    /**
     * @generated from field: int64 messageId = 1;
     */
    messageId: bigint;

    /**
     * @generated from field: int64 clientTs = 2;
     */
    clientTs: bigint;

    /**
     * @generated from field: string clientUuid = 3;
     */
    clientUuid: string;

    /**
     * @generated from field: optional int64 targetChatId = 4;
     */
    targetChatId?: bigint;

    /**
     * @generated from field: optional int64 targetContactId = 5;
     */
    targetContactId?: bigint;

    /**
     * @generated from field: repeated string payloadIds = 6;
     */
    payloadIds: string[];
  };

/**
 * Describes the message com.gem.bff.contract.ForwardMessagesRequest.ForwardData.
 * Use `create(ForwardMessagesRequest_ForwardDataSchema)` to create a new message.
 */
export const ForwardMessagesRequest_ForwardDataSchema: GenMessage<ForwardMessagesRequest_ForwardData> =
  /*@__PURE__*/
  messageDesc(file_message_message_requests, 14, 0);

/**
 * @generated from message com.gem.bff.contract.DeleteMessagesRequest
 */
export type DeleteMessagesRequest = Message<'com.gem.bff.contract.DeleteMessagesRequest'> & {
  /**
   * @generated from field: int64 chatId = 1;
   */
  chatId: bigint;

  /**
   * @generated from field: repeated int64 messageIds = 2;
   */
  messageIds: bigint[];

  /**
   * @generated from field: com.gem.bff.contract.Message.DeleteMode mode = 3;
   */
  mode: Message_DeleteMode;
};

/**
 * Describes the message com.gem.bff.contract.DeleteMessagesRequest.
 * Use `create(DeleteMessagesRequestSchema)` to create a new message.
 */
export const DeleteMessagesRequestSchema: GenMessage<DeleteMessagesRequest> =
  /*@__PURE__*/
  messageDesc(file_message_message_requests, 15);

/**
 * @generated from message com.gem.bff.contract.SendMessagePayloadData
 */
export type SendMessagePayloadData = Message<'com.gem.bff.contract.SendMessagePayloadData'> & {
  /**
   * @generated from oneof com.gem.bff.contract.SendMessagePayloadData.payload
   */
  payload:
    | {
        /**
         * @generated from field: com.gem.bff.contract.SendMessagePayloadData.OrderedItemData orderedItem = 1;
         */
        value: SendMessagePayloadData_OrderedItemData;
        case: 'orderedItem';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.SendMessagePayloadData.AlbumData album = 2;
         */
        value: SendMessagePayloadData_AlbumData;
        case: 'album';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.SendMessagePayloadData.StickerData sticker = 3;
         */
        value: SendMessagePayloadData_StickerData;
        case: 'sticker';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.SendMessagePayloadData.TextData text = 4;
         */
        value: SendMessagePayloadData_TextData;
        case: 'text';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.SendMessagePayloadData.FileData file = 5;
         */
        value: SendMessagePayloadData_FileData;
        case: 'file';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.SendMessagePayloadData.ImageData image = 6;
         */
        value: SendMessagePayloadData_ImageData;
        case: 'image';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.SendMessagePayloadData.VideoData video = 7;
         */
        value: SendMessagePayloadData_VideoData;
        case: 'video';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.SendMessagePayloadData.AudioData audio = 8;
         */
        value: SendMessagePayloadData_AudioData;
        case: 'audio';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.SendMessagePayloadData.VoiceData voice = 9;
         */
        value: SendMessagePayloadData_VoiceData;
        case: 'voice';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.SendMessagePayloadData.E2eeData e2ee = 10;
         */
        value: SendMessagePayloadData_E2eeData;
        case: 'e2ee';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.bff.contract.SendMessagePayloadData.
 * Use `create(SendMessagePayloadDataSchema)` to create a new message.
 */
export const SendMessagePayloadDataSchema: GenMessage<SendMessagePayloadData> =
  /*@__PURE__*/
  messageDesc(file_message_message_requests, 16);

/**
 * @generated from message com.gem.bff.contract.SendMessagePayloadData.OrderedItemData
 */
export type SendMessagePayloadData_OrderedItemData =
  Message<'com.gem.bff.contract.SendMessagePayloadData.OrderedItemData'> & {
    /**
     * @generated from field: string id = 1;
     */
    id: string;

    /**
     * @generated from field: int32 order = 2;
     */
    order: number;

    /**
     * @generated from field: com.gem.bff.contract.SendMessagePayloadData payload = 3;
     */
    payload?: SendMessagePayloadData;
  };

/**
 * Describes the message com.gem.bff.contract.SendMessagePayloadData.OrderedItemData.
 * Use `create(SendMessagePayloadData_OrderedItemDataSchema)` to create a new message.
 */
export const SendMessagePayloadData_OrderedItemDataSchema: GenMessage<SendMessagePayloadData_OrderedItemData> =
  /*@__PURE__*/
  messageDesc(file_message_message_requests, 16, 0);

/**
 * @generated from message com.gem.bff.contract.SendMessagePayloadData.AlbumData
 */
export type SendMessagePayloadData_AlbumData =
  Message<'com.gem.bff.contract.SendMessagePayloadData.AlbumData'> & {
    /**
     * @generated from field: repeated com.gem.bff.contract.SendMessagePayloadData.OrderedItemData payloads = 1;
     */
    payloads: SendMessagePayloadData_OrderedItemData[];

    /**
     * @generated from field: optional string comment = 2;
     */
    comment?: string;
  };

/**
 * Describes the message com.gem.bff.contract.SendMessagePayloadData.AlbumData.
 * Use `create(SendMessagePayloadData_AlbumDataSchema)` to create a new message.
 */
export const SendMessagePayloadData_AlbumDataSchema: GenMessage<SendMessagePayloadData_AlbumData> =
  /*@__PURE__*/
  messageDesc(file_message_message_requests, 16, 1);

/**
 * @generated from message com.gem.bff.contract.SendMessagePayloadData.StickerData
 */
export type SendMessagePayloadData_StickerData =
  Message<'com.gem.bff.contract.SendMessagePayloadData.StickerData'> & {
    /**
     * @generated from field: int64 id = 1;
     */
    id: bigint;

    /**
     * @generated from field: int64 stickerPackId = 2;
     */
    stickerPackId: bigint;
  };

/**
 * Describes the message com.gem.bff.contract.SendMessagePayloadData.StickerData.
 * Use `create(SendMessagePayloadData_StickerDataSchema)` to create a new message.
 */
export const SendMessagePayloadData_StickerDataSchema: GenMessage<SendMessagePayloadData_StickerData> =
  /*@__PURE__*/
  messageDesc(file_message_message_requests, 16, 2);

/**
 * @generated from message com.gem.bff.contract.SendMessagePayloadData.TextData
 */
export type SendMessagePayloadData_TextData =
  Message<'com.gem.bff.contract.SendMessagePayloadData.TextData'> & {
    /**
     * @generated from field: string text = 1;
     */
    text: string;

    /**
     * @generated from field: optional com.gem.bff.contract.LinkPreview linkPreview = 2;
     */
    linkPreview?: LinkPreview;

    /**
     * @generated from field: optional bool linkPreviewCancelled = 3;
     */
    linkPreviewCancelled?: boolean;
  };

/**
 * Describes the message com.gem.bff.contract.SendMessagePayloadData.TextData.
 * Use `create(SendMessagePayloadData_TextDataSchema)` to create a new message.
 */
export const SendMessagePayloadData_TextDataSchema: GenMessage<SendMessagePayloadData_TextData> =
  /*@__PURE__*/
  messageDesc(file_message_message_requests, 16, 3);

/**
 * @generated from message com.gem.bff.contract.SendMessagePayloadData.FileData
 */
export type SendMessagePayloadData_FileData =
  Message<'com.gem.bff.contract.SendMessagePayloadData.FileData'> & {
    /**
     * @generated from field: string url = 1;
     */
    url: string;

    /**
     * @generated from field: optional string comment = 2;
     */
    comment?: string;
  };

/**
 * Describes the message com.gem.bff.contract.SendMessagePayloadData.FileData.
 * Use `create(SendMessagePayloadData_FileDataSchema)` to create a new message.
 */
export const SendMessagePayloadData_FileDataSchema: GenMessage<SendMessagePayloadData_FileData> =
  /*@__PURE__*/
  messageDesc(file_message_message_requests, 16, 4);

/**
 * @generated from message com.gem.bff.contract.SendMessagePayloadData.ImageData
 */
export type SendMessagePayloadData_ImageData =
  Message<'com.gem.bff.contract.SendMessagePayloadData.ImageData'> & {
    /**
     * @generated from field: string url = 1;
     */
    url: string;

    /**
     * @generated from field: optional string comment = 2;
     */
    comment?: string;
  };

/**
 * Describes the message com.gem.bff.contract.SendMessagePayloadData.ImageData.
 * Use `create(SendMessagePayloadData_ImageDataSchema)` to create a new message.
 */
export const SendMessagePayloadData_ImageDataSchema: GenMessage<SendMessagePayloadData_ImageData> =
  /*@__PURE__*/
  messageDesc(file_message_message_requests, 16, 5);

/**
 * @generated from message com.gem.bff.contract.SendMessagePayloadData.VideoData
 */
export type SendMessagePayloadData_VideoData =
  Message<'com.gem.bff.contract.SendMessagePayloadData.VideoData'> & {
    /**
     * @generated from field: string url = 1;
     */
    url: string;

    /**
     * @generated from field: optional string comment = 2;
     */
    comment?: string;

    /**
     * @generated from field: string previewUrl = 3;
     */
    previewUrl: string;

    /**
     * @generated from field: optional com.gem.bff.contract.GraphicSize graphicSize = 4;
     */
    graphicSize?: GraphicSize;
  };

/**
 * Describes the message com.gem.bff.contract.SendMessagePayloadData.VideoData.
 * Use `create(SendMessagePayloadData_VideoDataSchema)` to create a new message.
 */
export const SendMessagePayloadData_VideoDataSchema: GenMessage<SendMessagePayloadData_VideoData> =
  /*@__PURE__*/
  messageDesc(file_message_message_requests, 16, 6);

/**
 * @generated from message com.gem.bff.contract.SendMessagePayloadData.AudioData
 */
export type SendMessagePayloadData_AudioData =
  Message<'com.gem.bff.contract.SendMessagePayloadData.AudioData'> & {
    /**
     * @generated from field: string url = 1;
     */
    url: string;

    /**
     * @generated from field: optional string comment = 2;
     */
    comment?: string;

    /**
     * @generated from field: optional string artist = 3;
     */
    artist?: string;

    /**
     * @generated from field: optional string title = 4;
     */
    title?: string;

    /**
     * @generated from field: int64 duration = 5;
     */
    duration: bigint;
  };

/**
 * Describes the message com.gem.bff.contract.SendMessagePayloadData.AudioData.
 * Use `create(SendMessagePayloadData_AudioDataSchema)` to create a new message.
 */
export const SendMessagePayloadData_AudioDataSchema: GenMessage<SendMessagePayloadData_AudioData> =
  /*@__PURE__*/
  messageDesc(file_message_message_requests, 16, 7);

/**
 * @generated from message com.gem.bff.contract.SendMessagePayloadData.VoiceData
 */
export type SendMessagePayloadData_VoiceData =
  Message<'com.gem.bff.contract.SendMessagePayloadData.VoiceData'> & {
    /**
     * @generated from field: string url = 1;
     */
    url: string;

    /**
     * @generated from field: optional string comment = 2;
     */
    comment?: string;

    /**
     * @generated from field: int64 duration = 3;
     */
    duration: bigint;

    /**
     * @generated from field: string histogram = 4;
     */
    histogram: string;
  };

/**
 * Describes the message com.gem.bff.contract.SendMessagePayloadData.VoiceData.
 * Use `create(SendMessagePayloadData_VoiceDataSchema)` to create a new message.
 */
export const SendMessagePayloadData_VoiceDataSchema: GenMessage<SendMessagePayloadData_VoiceData> =
  /*@__PURE__*/
  messageDesc(file_message_message_requests, 16, 8);

/**
 * @generated from message com.gem.bff.contract.SendMessagePayloadData.E2eeData
 */
export type SendMessagePayloadData_E2eeData =
  Message<'com.gem.bff.contract.SendMessagePayloadData.E2eeData'> & {
    /**
     * @generated from field: int64 epoch = 1;
     */
    epoch: bigint;

    /**
     * @generated from field: string senderDeviceId = 2;
     */
    senderDeviceId: string;

    /**
     * @generated from field: bytes payload = 3;
     */
    payload: Uint8Array;

    /**
     * @generated from field: optional bytes selfPayload = 4;
     */
    selfPayload?: Uint8Array;
  };

/**
 * Describes the message com.gem.bff.contract.SendMessagePayloadData.E2eeData.
 * Use `create(SendMessagePayloadData_E2eeDataSchema)` to create a new message.
 */
export const SendMessagePayloadData_E2eeDataSchema: GenMessage<SendMessagePayloadData_E2eeData> =
  /*@__PURE__*/
  messageDesc(file_message_message_requests, 16, 9);

/**
 * @generated from message com.gem.bff.contract.SearchMessagesRequest
 */
export type SearchMessagesRequest = Message<'com.gem.bff.contract.SearchMessagesRequest'> & {
  /**
   * @generated from field: int64 chatId = 1;
   */
  chatId: bigint;

  /**
   * @generated from field: string query = 2;
   */
  query: string;

  /**
   * @generated from field: optional string cursor = 3;
   */
  cursor?: string;

  /**
   * @generated from field: optional int32 limit = 4;
   */
  limit?: number;
};

/**
 * Describes the message com.gem.bff.contract.SearchMessagesRequest.
 * Use `create(SearchMessagesRequestSchema)` to create a new message.
 */
export const SearchMessagesRequestSchema: GenMessage<SearchMessagesRequest> =
  /*@__PURE__*/
  messageDesc(file_message_message_requests, 17);

/**
 * @generated from message com.gem.bff.contract.GetLinkPreviewRequest
 */
export type GetLinkPreviewRequest = Message<'com.gem.bff.contract.GetLinkPreviewRequest'> & {
  /**
   * @generated from field: string link = 1;
   */
  link: string;
};

/**
 * Describes the message com.gem.bff.contract.GetLinkPreviewRequest.
 * Use `create(GetLinkPreviewRequestSchema)` to create a new message.
 */
export const GetLinkPreviewRequestSchema: GenMessage<GetLinkPreviewRequest> =
  /*@__PURE__*/
  messageDesc(file_message_message_requests, 18);

/**
 * @generated from message com.gem.bff.contract.GetMessagesCountsRequest
 */
export type GetMessagesCountsRequest = Message<'com.gem.bff.contract.GetMessagesCountsRequest'> & {
  /**
   * @generated from field: int64 chatId = 1;
   */
  chatId: bigint;
};

/**
 * Describes the message com.gem.bff.contract.GetMessagesCountsRequest.
 * Use `create(GetMessagesCountsRequestSchema)` to create a new message.
 */
export const GetMessagesCountsRequestSchema: GenMessage<GetMessagesCountsRequest> =
  /*@__PURE__*/
  messageDesc(file_message_message_requests, 19);

/**
 * @generated from message com.gem.bff.contract.ScheduleMessageRequest
 */
export type ScheduleMessageRequest = Message<'com.gem.bff.contract.ScheduleMessageRequest'> & {
  /**
   * @generated from field: int64 chatId = 1;
   */
  chatId: bigint;

  /**
   * @generated from field: string clientUuid = 2;
   */
  clientUuid: string;

  /**
   * @generated from field: int64 clientTs = 3;
   */
  clientTs: bigint;

  /**
   * @generated from field: int64 delayMs = 4;
   */
  delayMs: bigint;

  /**
   * @generated from field: com.gem.bff.contract.SendMessagePayloadData payload = 5;
   */
  payload?: SendMessagePayloadData;

  /**
   * @generated from field: optional com.gem.bff.contract.QuotedMessageRequestData quotedMessageData = 6;
   */
  quotedMessageData?: QuotedMessageRequestData;
};

/**
 * Describes the message com.gem.bff.contract.ScheduleMessageRequest.
 * Use `create(ScheduleMessageRequestSchema)` to create a new message.
 */
export const ScheduleMessageRequestSchema: GenMessage<ScheduleMessageRequest> =
  /*@__PURE__*/
  messageDesc(file_message_message_requests, 20);

/**
 * @generated from message com.gem.bff.contract.UpdateScheduledMessageRequest
 */
export type UpdateScheduledMessageRequest =
  Message<'com.gem.bff.contract.UpdateScheduledMessageRequest'> & {
    /**
     * @generated from field: int64 chatId = 1;
     */
    chatId: bigint;

    /**
     * @generated from field: int64 messageId = 2;
     */
    messageId: bigint;

    /**
     * @generated from field: int64 clientTs = 3;
     */
    clientTs: bigint;

    /**
     * @generated from field: int64 delayMs = 4;
     */
    delayMs: bigint;

    /**
     * @generated from field: com.gem.bff.contract.SendMessagePayloadData payload = 5;
     */
    payload?: SendMessagePayloadData;

    /**
     * @generated from field: optional com.gem.bff.contract.QuotedMessageRequestData quotedMessageData = 6;
     */
    quotedMessageData?: QuotedMessageRequestData;
  };

/**
 * Describes the message com.gem.bff.contract.UpdateScheduledMessageRequest.
 * Use `create(UpdateScheduledMessageRequestSchema)` to create a new message.
 */
export const UpdateScheduledMessageRequestSchema: GenMessage<UpdateScheduledMessageRequest> =
  /*@__PURE__*/
  messageDesc(file_message_message_requests, 21);

/**
 * @generated from message com.gem.bff.contract.DeleteScheduledMessagesRequest
 */
export type DeleteScheduledMessagesRequest =
  Message<'com.gem.bff.contract.DeleteScheduledMessagesRequest'> & {
    /**
     * @generated from field: int64 chatId = 1;
     */
    chatId: bigint;

    /**
     * @generated from field: repeated int64 messageIds = 2;
     */
    messageIds: bigint[];
  };

/**
 * Describes the message com.gem.bff.contract.DeleteScheduledMessagesRequest.
 * Use `create(DeleteScheduledMessagesRequestSchema)` to create a new message.
 */
export const DeleteScheduledMessagesRequestSchema: GenMessage<DeleteScheduledMessagesRequest> =
  /*@__PURE__*/
  messageDesc(file_message_message_requests, 22);

/**
 * @generated from message com.gem.bff.contract.SendScheduledMessageNowRequest
 */
export type SendScheduledMessageNowRequest =
  Message<'com.gem.bff.contract.SendScheduledMessageNowRequest'> & {
    /**
     * @generated from field: int64 chatId = 1;
     */
    chatId: bigint;

    /**
     * @generated from field: int64 messageId = 2;
     */
    messageId: bigint;
  };

/**
 * Describes the message com.gem.bff.contract.SendScheduledMessageNowRequest.
 * Use `create(SendScheduledMessageNowRequestSchema)` to create a new message.
 */
export const SendScheduledMessageNowRequestSchema: GenMessage<SendScheduledMessageNowRequest> =
  /*@__PURE__*/
  messageDesc(file_message_message_requests, 23);

/**
 * @generated from message com.gem.bff.contract.GetScheduledMessagesRequest
 */
export type GetScheduledMessagesRequest =
  Message<'com.gem.bff.contract.GetScheduledMessagesRequest'> & {
    /**
     * @generated from field: int64 chatId = 1;
     */
    chatId: bigint;

    /**
     * @generated from field: int32 limit = 2;
     */
    limit: number;

    /**
     * @generated from field: optional string cursor = 3;
     */
    cursor?: string;
  };

/**
 * Describes the message com.gem.bff.contract.GetScheduledMessagesRequest.
 * Use `create(GetScheduledMessagesRequestSchema)` to create a new message.
 */
export const GetScheduledMessagesRequestSchema: GenMessage<GetScheduledMessagesRequest> =
  /*@__PURE__*/
  messageDesc(file_message_message_requests, 24);

/**
 * @generated from message com.gem.bff.contract.GetScheduledMessagesByIdsRequest
 */
export type GetScheduledMessagesByIdsRequest =
  Message<'com.gem.bff.contract.GetScheduledMessagesByIdsRequest'> & {
    /**
     * @generated from field: int64 chatId = 1;
     */
    chatId: bigint;

    /**
     * @generated from field: repeated int64 messageIds = 2;
     */
    messageIds: bigint[];
  };

/**
 * Describes the message com.gem.bff.contract.GetScheduledMessagesByIdsRequest.
 * Use `create(GetScheduledMessagesByIdsRequestSchema)` to create a new message.
 */
export const GetScheduledMessagesByIdsRequestSchema: GenMessage<GetScheduledMessagesByIdsRequest> =
  /*@__PURE__*/
  messageDesc(file_message_message_requests, 25);
